import { getCandleCommodities } from "@/_core/data/api_calls/candle_data/getCandleCommodities";
import { getCandleEtfs } from "@/_core/data/api_calls/candle_data/getCandleEtfs";
import { getCandleFutures } from "@/_core/data/api_calls/candle_data/getCandleFutures";
import { getCandleIndex } from "@/_core/data/api_calls/candle_data/getCandleIndex";
import { getCandleInterestRate } from "@/_core/data/api_calls/candle_data/getCandleInterestRate";
import { getCandleTechnicalAnalysisCurrencies } from "@/_core/data/api_calls/candle_data/getCandleTechnicalAnalysisCurrencies";
import { getCommoditiesData } from "@/_core/data/api_calls/getCommoditiesData";

/**
 * Fetches candle data for various asset types, including:
 * - Commodities
 * - Interest rates
 * - Indices
 * - Futures
 * - ETFs
 * - Currencies (with technical analysis support)
 *
 * @param {object} _this - Vue component instance or execution context.
 * @param {string} asset - Asset type (default is "currency").
 * @param {object} assetExtraParams - Additional parameters related to the asset.
 * @returns {Promise} - Returns a promise resolving with the asset's candle data.
 */
export function getCandleData(
  _this,
  asset = "currency",
  assetExtraParams = {}
) {
  switch (asset) {
    case "commodity":
      return getCandleCommodities(_this, assetExtraParams);
    case "commodity_contract":
      return getCommoditiesData(_this, assetExtraParams);
    case "interest_rate":
      return getCandleInterestRate(_this, assetExtraParams);
    case "index":
      return getCandleIndex(_this, assetExtraParams);
    case "futures":
      return getCandleFutures(_this, assetExtraParams);
    case "etfs":
      return getCandleEtfs(_this, assetExtraParams);
    case "technical_analysis_historical":
    case "currency":
    case "currency_historical":
      return getCandleTechnicalAnalysisCurrencies(_this, assetExtraParams);
    default:
      throw new Error(`Unsupported asset type: ${asset}`);
  }
}
